import { render } from "./CourseWiseBreakDown.vue?vue&type=template&id=4c20ebdb&ts=true"
import script from "./CourseWiseBreakDown.vue?vue&type=script&lang=ts"
export * from "./CourseWiseBreakDown.vue?vue&type=script&lang=ts"

import "./CourseWiseBreakDown.vue?vue&type=style&index=0&id=4c20ebdb&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__